<template>
<button class="mdc-button button" @click="$emit('click')">
  <slot />
</button>
</template>
<script>
import { MDCRipple } from '@material/ripple'

export default {
  name: "bk-flat-button",
  mounted () {
    new MDCRipple(document.querySelector('.mdc-button'))
  },
}
</script>
<style lang="scss" scoped>
  @import "../scss/colors";
  @import "../../node_modules/@material/button/mdc-button";
</style>
